import omit from 'lodash/omit'

type PropType = string | number | symbol

export function omitDeep(input: any, props: PropType | PropType[]): any {
  function omitDeepOnOwnProps(obj: any): any {
    if (typeof input === 'undefined') {
      return input
    }

    if (!Array.isArray(obj) && !isObject(obj)) {
      return obj
    }

    if (Array.isArray(obj)) {
      return omitDeep(obj, props)
    }

    const o: { [key: string]: any } = {}
    for (const [key, value] of Object.entries(obj)) {
      o[key] = !isNil(value) ? omitDeep(value, props) : value
    }

    return omit(o, props)
  }

  if (arguments.length > 2) {
    // eslint-disable-next-line prefer-rest-params
    props = Array.prototype.slice.call(arguments).slice(1)
  }

  if (Array.isArray(input)) {
    return input.map(omitDeepOnOwnProps)
  }

  return omitDeepOnOwnProps(input)
}

function isNil(value: any): value is null | undefined {
  return value === null || value === undefined
}

function isObject(obj: any): obj is object {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
